export const SPLIT_HIEROGLYPHS_ONLY = /[^\u4e00-\u9fff]+|[\u4e00-\u9fff]/gi;
